import beautify from 'js-beautify';

var editor = ace.edit("editor");
editor.setTheme("ace/theme/monokai");
editor.session.setMode("ace/mode/html");

let paragraphCount = {
    left: 0,
    right: 0
};

function addParagraph(column) {
    paragraphCount[column]++;

    const columnContainer = document.getElementById(column + 'Column');
    const paragraphDiv = document.createElement('div');
    paragraphDiv.classList.add('paragraph');

    const titleLabel = document.createElement('label');
    titleLabel.innerText = `Paragraph ${paragraphCount[column]} Title:`;
    paragraphDiv.appendChild(titleLabel);

    const titleInput = document.createElement('input');
    titleInput.type = 'text';
    titleInput.id = `${column}Title${paragraphCount[column]}`;
    paragraphDiv.appendChild(titleInput);

    const textLabel = document.createElement('label');
    textLabel.innerText = `Paragraph ${paragraphCount[column]} Text:`;
    paragraphDiv.appendChild(textLabel);

    const textInput = document.createElement('textarea');
    textInput.id = `${column}Text${paragraphCount[column]}`;
    paragraphDiv.appendChild(textInput);

    columnContainer.appendChild(paragraphDiv);
}

function generateHTML() {
    let htmlCode = `<!-- CSS -->\n
    <style>
        .SEO-categ-sport .x-cg-10-rem{-moz-column-gap:1em;column-gap:1em}.SEO-categ-sport .x-fweight-600{font-weight:600}.SEO-categ-sport .x-fweight-700{font-weight:700}.SEO-categ-sport .x-margin-b-05{margin-bottom:.5em}.SEO-categ-sport .x-rg-5-rem{row-gap:.5rem}.SEO-categ-sport .x-rg-10-rem{row-gap:1rem}.SEO-categ-sport .x-flex{display:flex}.SEO-categ-sport .x-width-100{width:100%!important}.SEO-categ-sport .x-align-left{text-align:left}.SEO-categ-sport .x-align-center{text-align:center}.SEO-categ-sport .x-jcontent-fs{justify-content:flex-start}.SEO-categ-sport .x-aitem-fs{align-items:flex-start}.SEO-categ-sport .x-fdirection-c{flex-direction:column}.SEO-categ-sport .x-upper{text-transform:uppercase}.SEO-categ-sport strong{font-weight:bolder}.SEO-categ-sport ::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}.SEO-categ-sport .label-01{text-align:justify}@media screen and (min-width:1024px){.SEO-categ-sport .x-margin-b-15-l{margin-bottom:1.5em}.SEO-categ-sport .x-rg-10-rem-l{row-gap:1rem}.SEO-categ-sport .x-width-50-l{width:50%!important}.SEO-categ-sport .x-fdirection-r-l{flex-direction:row}}
    </style>
    \n\n`;

    htmlCode += `<section class="SEO-categ-sport">\n`;
    htmlCode += `    <article class="x-width-100 x-flex x-fdirection-c x-aitem-fs x-jcontent-fs x-rg-10-rem x-rg-10-rem-l">`;

    const sectionTitle = document.getElementById(`sectionTitle`).value;
    const sectionSubtitle = document.getElementById(`sectionSubtitle`).value;
    const sectionText = document.getElementById(`sectionSubtitleText`).value;

    htmlCode += `
        <div class="x-width-100 x-flex x-fdirection-c x-aitem-fs x-jcontent-fs x-rg-5-rem x-rg-05-rem-l x-align-left">

            <h2 class="x-width-100 title-01 x-margin-b-05 x-margin-b-15-l x-upper x-align-center x-fweight-700">
                ${sectionTitle}
            </h2>

            <h3 class="label-01 x-fweight-700 x-align-left">
                ${sectionSubtitle}
            </h3>

            <p class="label-01"> 
                ${sectionText}
            </p>

        </div>
        \n
        <div class="x-flex x-fdirection-c x-fdirection-r-l x-aitem-fs x-jcontent-fs x-rg-10-rem x-rg-10-rem-l x-cg-10-rem x-width-100">
`;

    // Left Column
    htmlCode += `        <div class="x-flex x-fdirection-c x-aitem-fs x-jcontent-fs x-rg-10-rem x-rg-10-rem-l x-width-50-l x-width-100">\n`;
    for (let i = 1; i <= paragraphCount.left; i++) {
        const title = document.getElementById(`leftTitle${i}`).value;
        const text = document.getElementById(`leftText${i}`).value;

        if (title || text) {
            htmlCode += `            <div class="x-flex x-fdirection-c x-aitem-fs x-jcontent-fs x-rg-5-rem x-rg-05-rem-l">\n`;

            if (title) {
                htmlCode += `                <h3 class="label-01 x-fweight-600">${title}</h3>\n`;
            }

            if (text) {
                htmlCode += `                <p class="label-01">${text}</p>\n`;
            }

            htmlCode += `            </div>\n`;
        }
    }
    htmlCode += `        </div>\n`;

    // Right Column
    htmlCode += `        <div class="x-flex x-fdirection-c x-aitem-fs x-jcontent-fs x-rg-10-rem x-rg-10-rem-l x-width-50-l x-width-100">\n`;
    for (let i = 1; i <= paragraphCount.right; i++) {
        const title = document.getElementById(`rightTitle${i}`).value;
        const text = document.getElementById(`rightText${i}`).value;

        if (title || text) {
            htmlCode += `            <div class="x-flex x-fdirection-c x-aitem-fs x-jcontent-fs x-rg-5-rem x-rg-05-rem-l">\n`;

            if (title) {
                htmlCode += `                <h3 class="label-01 x-fweight-600">${title}</h3>\n`;
            }

            if (text) {
                htmlCode += `                <p class="label-01">${text}</p>\n`;
            }

            htmlCode += `            </div>\n`;
        }
    }
    htmlCode += `        </div>\n`;

    htmlCode += `    </div>\n</article>\n</section>\n`;

    editor.session.setValue(beautify.html(htmlCode));
}

// Event Listeners for buttons
document.getElementById('addLeftParagraph').addEventListener('click', function () {
    addParagraph('left');
});

document.getElementById('addRightParagraph').addEventListener('click', function () {
    addParagraph('right');
});

document.getElementById('generateHTMLButton').addEventListener('click', generateHTML);